import { cellToLatLng, cellToBoundary } from "h3-js";

export const getEntityData = (id, entityType, data) => {
  console.log("id: " + id);
  console.log("data with entity", entityType, data);
  switch (entityType) {
    case "orders":
      return (
        data?.allOrders?.filter((order) => order?._id === id) ||
        data?.orderMarkers?.filter((order) => order?._id === id) ||
        []
      );
    case "drivers":
      const matchingDriversFromAllDrivers =
        data?.allDrivers?.filter((driver) => driver?._id === id) || [];
      const matchingDriversFromData =
        data?.data?.filter((driver) => driver?._id === id) || [];

      if (matchingDriversFromAllDrivers.length > 0) {
        return matchingDriversFromAllDrivers;
      } else if (matchingDriversFromData.length > 0) {
        return matchingDriversFromData;
      } else if (Array.isArray(data)) {
        return data;
      } else {
        return [data];
      }
    case "outlets":
      return (
        (data?.totalOutletData &&
          data?.totalOutletData.filter(
            (outlet) => outlet?._id === id || outlet?.id === id
          )) ||
        (data?.outlets &&
          data?.outlets.filter(
            (outlet) => outlet?._id === id || outlet?.id === id
          )) ||
        (data?.outletMarkers &&
          data?.outletMarkers.filter(
            (outlet) => outlet?._id === id || outlet?.id === id
          )) ||
        [data]
      );
    case "hubspots":
      const hotspots = (
        data?.activeHotspotsList ||
        data?.hotspotMarkers ||
        []
      ).filter(
        (hubspot) => hubspot?._id === id
      );

      console.log("hotspots  check", hotspots[0]);
      if (data?.hotspotMarkers) {
        return hotspots?.[0]?.outlets || [];
      }
      const totalOutlets =
        hotspots &&
        hotspots[0] &&
        hotspots[0].outlets.map((outlet) => {
          return data?.activeFoodOutletsList.find((o) => o?._id === outlet);
        });
      console.log(totalOutlets);
      return totalOutlets;
    default:
      return [];
  }
};

export const getHexCenter = (hexString) => {
  const center = cellToLatLng(hexString);

  return [center[0], center[1]];
};

export const getHexBoundaries = (hexString) => {
  const boundary = cellToBoundary(hexString);

  return boundary.map(([lat, lng]) => ({ lat, lng }));
};

// Function to calculate the distance between two lat/lng points using Haversine formula
export const haversineDistance = ([lat1, lon1], [lat2, lon2]) => {
  const R = 6371; // Radius of the Earth in kilometers
  const toRadians = (degrees) => (degrees * Math.PI) / 180;

  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distance in kilometers
};

// Get the radius of an H3 hexagon
export const getH3HexagonRadius = (hexId) => {
  const center = cellToLatLng(hexId); // Get center of hexagon
  const boundary = cellToBoundary(hexId); // Get the boundary points of hexagon

  // Calculate the distance between center and the first boundary point (representing the radius)
  const radius = haversineDistance(center, boundary[0]);

  return radius; // Distance in kilometers
};

export const getDefaultCenter = (data, entityType) => {
  if (entityType === "drivers" && data && data.length > 0) {
    const firstDriver = data[0];
    const lat = parseFloat(firstDriver?.coordinatesX);
    const lng = parseFloat(firstDriver?.coordinatesY);

    if (!isNaN(lat) && !isNaN(lng)) {
      return { lat, lng };
    }
  } else if (entityType === "outlets" && data && data.length > 0) {
    const firstOutlet = data[0];
    const lat = parseFloat(firstOutlet?.business_coordinatesX);
    const lng = parseFloat(firstOutlet?.business_coordinatesY);

    if (!isNaN(lat) && !isNaN(lng)) {
      return { lat, lng };
    }
  } else if (entityType === "hubspots" && data && data.length > 0) {
    const firstHubspot = data[0];
    return {
      lat: firstHubspot.lat,
      lng: firstHubspot.lng,
    };
  }

  // Fallback to UK if no valid coordinates found
  return { lat: 54.5, lng: -3.0 };
};

export const isValidCoordinate = (coordinate) => {
  // Check if lat and lng are valid numbers
  if (
    coordinate &&
    !isNaN(coordinate.lat) &&
    !isNaN(coordinate.lng) &&
    coordinate.lat >= -90 &&
    coordinate.lat <= 90 &&
    coordinate.lng >= -180 &&
    coordinate.lng <= 180
  ) {
    return true;
  }
  return false;
};

export const parseCoordinates = (coordinates) => {
  const [lat, lng] = coordinates
    .split(",")
    .map((coord) => parseFloat(coord.trim()));
  return { lat, lng };
};
